<ng-template [ngIf]="sezione">
<table class="fondo_rischi">
  <caption class="sr-only">Tabella petitum</caption>

  <tr class="selected_second_level">
    <th scope="row">
      Petitum <i>{{sezioneDatiEconomici ? sezione?.petitum?.tipoPetitum?.label : ''}}</i>
    </th>
    <td></td>
  </tr>

  <tr class="borded">
    <th scope="row">Importo</th>
    <td>
      {{(sezione?.petitum?.importoPetitum ? sezione?.petitum?.importoPetitum : '0') | euro}} &euro;
    </td>
  </tr>

  <tr class="borded">
    <th scope="row">Interessi legali</th>
    <td>
      {{(sezione?.petitum?.interessiPetitum ? sezione?.petitum?.interessiPetitum : '0') | euro}} &euro;
    </td>
  </tr>

  <tr class="borded last">
    <th scope="row">Rivalutazione</th>
    <td>
      {{(sezione?.petitum?.interessiRivalutazione ? sezione?.petitum?.interessiRivalutazione : '0') | euro}} &euro;
    </td>
  </tr>

  <tr class="borded last">
    <th scope="row">Maggior danno</th>
    <td>
      {{(sezione?.petitum?.interessiMaggiorDanno ? sezione?.petitum?.interessiMaggiorDanno : '0') | euro}} &euro;
    </td>
  </tr>

  <tr class="selected_second_level">
    <th scope="row">Totale</th>
    <td>
      {{calcolaSomma([
        (sezione?.petitum && sezione?.petitum?.tipoPetitum?.id == idPetitumQuantificabile &&
        sezione?.petitum?.importoPetitum ? '' + sezione?.petitum?.importoPetitum : '0'),
        (sezione?.petitum && sezione?.petitum?.tipoPetitum?.id == idPetitumQuantificabile &&
        sezione?.petitum?.interessiPetitum ? '' + sezione?.petitum?.interessiPetitum : '0'),
        (sezione?.petitum && sezione?.petitum?.interessiMaggiorDanno ? '' + sezione?.petitum?.interessiMaggiorDanno : '0'),
        (sezione?.petitum && sezione?.petitum?.interessiRivalutazione ? '' + sezione?.petitum?.interessiRivalutazione : '0'),
        (sezione?.petitum && sezione?.petitum?.spese ? '' + sezione?.petitum?.spese : '0'),
        (sezione?.petitum && sezione?.petitum?.interessiSpeseLegali ? '' + sezione?.petitum?.interessiSpeseLegali : '0')
      ])}} &euro;
    </td>
  </tr>
</table>

  <!--<table class="fondo_rischi">
    <tr class="selected_second_level">
      <td>Spese di giudizio</td>
      <td></td>
    </tr>
    <tr class="borded">
      <td>Compensi professionali</td>
      <td *ngIf="sezioneDatiEconomici">{{(sezione?.petitum?.spese ? sezione?.petitum?.spese : '0') | euro}} &euro;</td>
      <td *ngIf="!sezioneDatiEconomici"> </td>
    </tr>
     <tr class="borded">
      <td>Spese legali</td>
      <td>{{(sezione?.petitum?.spese ? sezione?.petitum?.spese : '0') | euro}} &euro;</td>
    </tr> 
    <tr class="borded">
      <td>Spese vive</td>
      <td>{{(sezione?.petitum?.altro ? sezione?.petitum?.altro : '0') | euro}} &euro;</td>
    </tr>
    <tr class="selected_second_level">
      <td>Totale</td>
      <td *ngIf="sezioneDatiEconomici">{{calcolaSomma([
        (sezione?.petitum && sezione?.petitum?.spese ? '' + sezione?.petitum?.spese : '0'),
        (sezione?.petitum && sezione?.petitum?.altro ? '' + sezione?.petitum?.altro : '0')])}} &euro;
      </td>
    </tr>
  </table>-->
</ng-template>

<!--<ng-template [ngIf]="!recuperoCrediti">
  <table class="fondo_rischi">
    <tr class="selected_second_level">
      <td>Petitum <i>{{sezioneDatiEconomici ? sezione?.petitum?.tipoPetitum?.label : ''}}</i></td>
      <td>
      </td>
    </tr>

    <tr class="borded">
      <td>Importo</td>
      <td>{{(sezione?.petitum?.importoPetitum ? sezione?.petitum?.importoPetitum : '0') | euro}} &euro;</td>
    </tr>
    <tr class="borded">
      <td>Interessi</td>
      <td>{{(sezione?.petitum?.interessiPetitum ? sezione?.petitum?.interessiPetitum : '0') | euro}} &euro;</td>
    </tr>
    <tr class="borded">
      <td>Rivalutazione</td>
      <td>{{(sezione?.petitum?.interessiRivalutazione ? sezione?.petitum?.interessiRivalutazione : '0') | euro}} &euro;</td>
    </tr>
    <tr class="borded last">
      <td>Maggior danno</td>
      <td>{{(sezione?.petitum?.interessiMaggiorDanno ? sezione?.petitum?.interessiMaggiorDanno : '0') | euro}} &euro;</td>
    </tr>
    <tr class="selected_second_level">
      <td>Totale</td>
      <td>{{calcolaSomma([
        (sezione?.petitum && sezione?.petitum?.tipoPetitum?.id == idPetitumQuantificabile &&
        sezione?.petitum?.importoPetitum ? '' + sezione?.petitum?.importoPetitum : '0'),
        (sezione?.petitum && sezione?.petitum?.tipoPetitum?.id == idPetitumQuantificabile &&
        sezione?.petitum?.interessiRivalutazione ? '' + sezione?.petitum?.interessiRivalutazione : '0'),
        (sezione?.petitum && sezione?.petitum?.tipoPetitum?.id == idPetitumQuantificabile &&
        sezione?.petitum?.interessiPetitum ? '' + sezione?.petitum?.interessiPetitum : '0'),
        (sezione?.petitum && sezione?.petitum?.tipoPetitum?.id == idPetitumQuantificabile &&
        sezione?.petitum?.interessiMaggiorDanno ? '' + sezione?.petitum?.interessiMaggiorDanno : '0')])}} &euro;
      </td>
    </tr>
  </table>
</ng-template>-->